import { useTabsContext } from "./useTabContext";

export type TabContentProps = {
  value: number | string;
  children: React.ReactNode;
};

// TabContent component
export const TabContent: React.FC<TabContentProps> = ({
  value,
  children
}) => {
  const { activeTab } = useTabsContext();

  if (activeTab !== value) {
    return null;
  }

  return <div className="pt-4">{children}</div>;
};
